import { useState } from 'react';

/**
 * Thin state-grouping hook for CSV bulk-import orchestration.
 * Groups the modal visibility, preloaded file, and minimized job state
 * that the LuminaPatients page uses to drive UploadPatientsModal.
 *
 * No business logic — pure state management.
 */
export function useBulkImportFlow() {
  const [showUpload, setShowUpload] = useState(false);
  const [preloadedUploadFile, setPreloadedUploadFile] = useState(null);
  const [minimizedJobId, setMinimizedJobId] = useState(null);

  return {
    showUpload, setShowUpload,
    preloadedUploadFile, setPreloadedUploadFile,
    minimizedJobId, setMinimizedJobId,
  };
}
